<template>
    <!--  TOP SEARCH -->
  <div v-if="searchBar">
    <section class="uk-section uk-padding-remove-vertical my-location">
        <div class="uk-container uk-container-xsmall topsearch">
            <div uk-grid class="uk-flex uk-flex-middle uk-text-center">
                <div class="uk-width-full uk-text-center">
                    <div style="width: 100%;" class="uk-inline">
                        <span class="uk-form-icon" uk-icon="icon: search"></span>
                      <button class="uk-input search-input" uk-toggle="target: #modal-search" type="button"></button>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
      <div id="modal-search" uk-modal>
        <div class="uk-modal-dialog" style="border-radius: 8px;">

          <button class="uk-modal-close-default" type="button" uk-close></button>

          <div class="uk-modal-header" style="border-radius: 8px 8px 0 0;">
            <h2 class="uk-modal-title">
              <div class="uk-inline">
                <span class="uk-form-icon" uk-icon="icon: search"></span>
                <input class="uk-input uk-form-width-large" type="text" placeholder="Search" style="border-bottom: #a7a7a7 solid 1px">
              </div>
            </h2>
            <ul uk-tab>
              <li class="uk-active"><a href="#">All</a></li>
              <li><a href="#">Stores</a></li>
              <li><a href="#">Coupons</a></li>
              <li><a href="#">Loyalty</a></li>
            </ul>
          </div>

          <div class="uk-modal-body" uk-overflow-auto>

<!--            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>-->

<!--            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>-->

<!--            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>-->

<!--            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>-->

<!--            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>-->

<!--            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>-->

<!--            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>-->

<!--            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>-->

<!--            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>-->

          </div>

<!--          <div class="uk-modal-footer uk-text-right">-->
<!--            <button class="uk-button uk-button-default uk-modal-close" type="button">Cancel</button>-->
<!--            <button class="uk-button uk-button-primary" type="button">Save</button>-->
<!--          </div>-->

        </div>
      </div>
    </section>
  </div>
    <!--  // TOP SEARCH -->
</template>

<script>
import coreMixin from '../mixins/coreMixin'
// eslint-disable-next-line no-unused-vars
import configMixin from '../mixins/configMixin'
const searchBarDefault = false

export default {
  mixins: [coreMixin],
  computed: {
    searchBar () {
      if (this.$route.meta.searchbar !== '') {
        if (this.getConfig().showSearch === true) {
          return this.$route.meta.searchbar
        } else {
          return searchBarDefault
        }
      } else {
        return searchBarDefault
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TopSearch.vue